package features.booking

/**
 * Lógica pura (sin Firebase) de reprogramación / división / reasignación de asientos.
 * Extraída de BookingRepositoryImpl para poder testearla y tener una sola fuente de verdad
 * del reparto de dinero y de la guardia de asiento ocupado.
 */
object CalculoReprogramacion {

    /** Reparto de un pago al dividir un grupo. El residuo de la división entera se queda
     *  con el grupo original (los que se quedan), nunca se pierde. */
    data class DivisionPago(val pagaQuienSeVa: Int, val pagaQuienSeQueda: Int)

    fun dividirPago(totalPagado: Int, totalPersonas: Int, personasQueSeVan: Int): DivisionPago {
        if (totalPersonas <= 0) return DivisionPago(0, totalPagado)
        val costoPorPersona = totalPagado / totalPersonas
        val pagaQuienSeVa = costoPorPersona * personasQueSeVan
        val pagaQuienSeQueda = totalPagado - pagaQuienSeVa
        return DivisionPago(pagaQuienSeVa = pagaQuienSeVa, pagaQuienSeQueda = pagaQuienSeQueda)
    }

    /** Precio asignado a un asiento al reasignar un conflicto: reparte el monto pendiente
     *  entre los asientos en conflicto. Si no hay (caso borde), devuelve el monto completo. */
    fun precioPorAsientoConflicto(montoPendiente: Int, asientosEnConflicto: Int): Int {
        return if (asientosEnConflicto > 0) montoPendiente / asientosEnConflicto else montoPendiente
    }

    /** True si el asiento destino debe verificarse contra ocupación. Se omite el chequeo solo
     *  cuando es el MISMO viaje y el asiento ya pertenece a la reserva (no choca consigo misma). */
    fun requiereChequeoOcupacion(mismoViaje: Boolean, asientoDestino: Int, asientosActuales: List<Int>): Boolean {
        return !(mismoViaje && asientoDestino in asientosActuales)
    }
}
